<template>
  <div id="app" ref="app">
    <router-view></router-view>
    <BackTop />
  </div>
</template>

<script>
import CifuAPI from "@/utils/api";

export default {
  name: "App",
  watch: {
    $route() {
      let appDom = document.getElementById("app");
      appDom.scrollTop = 0;
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    getConfig() {
      CifuAPI.getConfig().then((res) => {
        if (res.code == 1) {
          this.$store.dispatch("setConfig", res.data);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("./assets/css/icon.css");
::v-deep .el-button--primary{
  background: #fbce00 !important;
  color: #663301 !important;
}
</style>
